const Spinner = ({ mark }) => {
  return (
    <div
      className={
        mark === "addForm"
          ? "spinner-border mx-auto"
          : "spinner-border mx-auto mt-5"
      }
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};

export default Spinner;
